import { render, staticRenderFns } from "./ReadingList.vue?vue&type=template&id=2f975b0f&scoped=true&"
import script from "./ReadingList.vue?vue&type=script&lang=ts&"
export * from "./ReadingList.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingList.vue?vue&type=style&index=0&id=2f975b0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f975b0f",
  null
  
)

export default component.exports